import { Platform, StyleSheet } from 'react-native';
import { spacing } from '../../../shared/theme/spacing';
import { ticketColors } from '../../../shared/theme/ticketColors'
import { ticketSurfaces } from '../../../shared/ticket/ticketSurfaces.styles';

export const supportDetailStyles = StyleSheet.create({
  scroll: {
    flex: 1,
    minHeight: 0,
  },
  content: {
    padding: spacing.lg,
    paddingBottom: spacing.xl * 2,
    gap: spacing.md,
  },
  contentWorkspace: {
    paddingHorizontal: spacing.md,
    paddingTop: spacing.md,
    paddingBottom: spacing.xl * 2,
    gap: spacing.md,
    maxWidth: '100%',
  },
  centered: {
    flex: 1,
    backgroundColor: ticketColors.bg,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: spacing.xxl,
  },
  loadingCaption: {
    fontSize: 13,
    color: ticketColors.ink2,
    marginTop: spacing.sm,
  },
  padded: {
    flex: 1,
    backgroundColor: ticketColors.bg,
    padding: spacing.lg,
  },
  errorText: {
    fontSize: 14,
    color: '#B45309',
  },

  // Hero meta
  heroMetaRow: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: spacing.sm,
  },
  heroDate: {
    fontSize: 13,
    color: ticketColors.ink3,
    fontWeight: '500',
  },

  // Section labels
  sectionLabel: {
    fontSize: 13,
    fontWeight: '600',
    color: ticketColors.ink2,
  },

  // Thread blocks
  threadHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  threadBlock: {
    ...ticketSurfaces.paperSheet,
    padding: spacing.md,
    gap: spacing.xs,
  },
  threadBlockStaff: {
    backgroundColor: ticketColors.brandSoft,
    borderColor: ticketColors.gold,
    borderWidth: 1.5,
  },
  threadLabel: {
    fontSize: 12,
    color: ticketColors.ink2,
    fontWeight: '600',
  },
  threadLabelStaff: {
    color: ticketColors.gold,
  },
  threadTime: {
    fontSize: 11,
    color: ticketColors.ink3,
  },
  threadBody: {
    fontSize: 15,
    color: ticketColors.ink,
    lineHeight: 22,
  },
  threadMeta: {
    fontSize: 11,
    color: ticketColors.ink3,
    marginTop: spacing.sm,
    lineHeight: 16,
  },

  // Pending
  pendingText: {
    fontSize: 14,
    color: ticketColors.ink2,
    lineHeight: 20,
  },

  surveyCard: {
    gap: spacing.sm,
    padding: spacing.md,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.warnBorder,
    backgroundColor: ticketColors.brandSoft,
  },
  surveyCardTitle: {
    fontSize: 15,
    fontWeight: '700',
    color: ticketColors.ink,
  },

  // Text input (shared)
  textInput: {
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 10,
    paddingHorizontal: spacing.md,
    paddingVertical: Platform.OS === 'ios' ? 12 : 10,
    color: ticketColors.ink,
    backgroundColor: ticketColors.paper2,
    fontSize: 15,
    fontWeight: '400',
    minHeight: 88,
  },

  // Survey section (inside soft-teal card)
  surveySection: {
    gap: spacing.sm,
  },
  surveyActions: {
    flexDirection: 'row',
    gap: spacing.sm,
  },
  surveyBtn: {
    flex: 1,
    minHeight: 44,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.gold,
    backgroundColor: '#FFFFFF',
    paddingVertical: spacing.sm,
    alignItems: 'center',
    justifyContent: 'center',
  },
  surveyBtnPrimary: {
    backgroundColor: ticketColors.gold,
    borderColor: ticketColors.gold,
  },
  surveyBtnText: {
    fontSize: 14,
    fontWeight: '600',
    color: ticketColors.brandInk,
  },
  surveyBtnPrimaryText: {
    fontSize: 14,
    fontWeight: '700',
    color: '#FFFFFF',
  },
  surveyFollowUp: {
    gap: spacing.sm,
  },
  surveyCancel: {
    alignSelf: 'flex-end',
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.md,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.warnBorder,
    backgroundColor: '#FFFFFF',
    minHeight: 40,
    justifyContent: 'center',
  },
  surveyCancelText: {
    fontSize: 14,
    fontWeight: '600',
    color: ticketColors.ink,
  },

  // Follow-up section
  followSection: {
    gap: spacing.sm,
  },

  // Send button (shared)
  sendBtn: {
    flexGrow: 0,
    flexBasis: 'auto',
    alignSelf: 'stretch',
    minHeight: 48,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.gold,
    paddingVertical: spacing.md,
    alignItems: 'center',
    justifyContent: 'center',
  },
  sendBtnDisabled: {
    opacity: 0.5,
  },
  sendBtnText: {
    fontSize: 15,
    fontWeight: '700',
    color: '#FFFFFF',
  },

  // Resolution panel (survey result display)
  resolutionPanel: {
    ...ticketSurfaces.paperSheet,
    padding: spacing.md,
    gap: spacing.xs,
  },
  resolutionTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: ticketColors.ink,
  },
  resolutionNoteLabel: {
    fontSize: 12,
    color: ticketColors.ink3,
    fontWeight: '600',
    marginTop: spacing.sm,
    marginBottom: spacing.xs,
  },
  resolutionNoteText: {
    fontSize: 14,
    color: ticketColors.ink,
    lineHeight: 20,
  },
});
